<div class="container">
    <div class="columns is-centered">
        <div class="box column is-one-third">
            <h1 class="title has-text-centered">Typing Game!</h1>
            <div class="tabs is-toggle">
                <ul>
                    <li><a (click) = "startSentenceQuiz()">Sentence</a></li>
                    <li><a (click) = "startPracticeTest()">Paragraph</a></li>
                    <li><a
                        [swal] = "{title: 'Typing Test', text:'The test will start upon closing this window!', allowOutsideClick: false}"
                        (confirm)="startTest()">Full Test</a></li>
                </ul>
            </div>

                <p *ngFor="let para of this.randomTextArr; let i = index;">
                    <span *ngFor="let char of para.split(''); let j = index;"
                    [class]="checkChar(char, i, j)">{{char}}</span>
                    <!-- <span *ngIf="i!==this.randomTextArr.length" [class]="checkChar('\n', i, j)">&nbsp;&nbsp;</span> -->
                    <br />
                    <br />
                </p>
                <!-- sentence generated in app.component.ts -->
            <button *ngIf="debugging" (click) = "playSound()">Show Difference</button>
            <div class="field">
                <input class="input" (focus)="resetTimerAfterTest()" (input)="getInputText($event)" *ngIf="textType === 'sentence'"/>
                <textarea class="textarea" (focus)="resetTimerAfterTest()" (input)="getInputText($event)" *ngIf="textType !== 'sentence'"></textarea>
            </div>
            <div class="box has-text-centered" *ngIf="(inputText === randomText)">
                <h3 class="title">Success!</h3>
                <h4 class="subtitle">Stats</h4>
                <ul>
                    <li>Time elapsed: {{ timeElapsedMin | number: '1.0-0'}}m {{ timeElapsedSec | number: '1.0-0'}}s</li>
                    <li>Words Per Minute: {{wpm | number: '1.0-2'}}</li>
                    <li>Characters Per Second: {{cps | number: '1.0-3'}}</li>
                </ul>
            </div>
        </div>
    </div>
</div>
